module.exports = __webpack_public_path__ + "static/img/bean_bg_img.488af9db.jpg";